const {vetrinaPhoneNumber} = require('src/settings');

export const whatsUpRedirectLink = `https://wa.me/${vetrinaPhoneNumber}`;
export const redirectToWhatsUp = (text) => {
	window.open(whatsUpRedirectLink + (text ? `?text=${encodeURIComponent(text)}` : ''), '_blank');
};

export const getProductLink = (product) => (product ? `/products/${product.id}` : '#');
